import { useState } from 'react';
import type { ReactNode, PropsWithChildren } from 'react';

import { CrossIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';

import st from './Info.module.sass';

interface InfoProps extends PropsWithChildren {
  icon: ReactNode;
  title: string;
  hideable?: boolean;
}

export function Info({
  icon,
  title,
  hideable = false,
  children = undefined,
}: InfoProps): JSX.Element | null {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  if (!isVisible) return null;

  return (
    <div className={st.InfoContainer}>
      {!!hideable && (
        <Control.IconButton
          className={st.HideIcon}
          icon={<CrossIcon />}
          onClick={() => setIsVisible(false)}
          variant="dimmed"
        />
      )}

      <div className={st.Header}>
        {icon}
        {title}
      </div>

      {children}
    </div>
  );
}
